export default __webpack_public_path__ + "static/media/fb.fa31adfc.svg";